import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from '@core/config.service';
import { HttpClient } from '@angular/common/http';
import { LocaleService } from '@app/services/locale/locale.service';

declare const window: any;

@Component({
  selector: 'pixie-dvic-banner',
  templateUrl: './dvic-banner.component.html',
  styleUrls: ['./dvic-banner.component.scss']
})

export class DvicBannerComponent implements OnInit {
    inViewObserver: IntersectionObserver;

    preferredLanguage;
    langSelection;
    geolocation;
    geolocationTwo;
    selectedLanguage;
    bannerOverride;
    dvicToggle;
    tokenCookie;
    authToken;
    webOrMobile;
    globalSiteId;
    environment;
    dvicScript;
    dvicimage;

  constructor(
      private cookieService: CookieService,
      private configService: ConfigService,
      private httpClient: HttpClient,
      private localeService: LocaleService,
    ) { }

  ngOnInit() {
        if (window.screen.width <= 480) {
            this.webOrMobile = 'mobile_web';
        } else {
            this.webOrMobile = 'web';
        }
        this.globalSiteId = 'dcl';
        this.dvicBanner();
        return window.screen.width;
    }

    getCookie(cname) {
        const name = cname + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }

    dvicBanner() {
        if (JSON.parse(this.getCookie('localeCookie_jar'))) {
            this.preferredLanguage = JSON.parse(this.getCookie('localeCookie_jar'))['preferredRegion'];
        }
        if (JSON.parse(this.getCookie('localeCookie_jar'))) {
            this.langSelection = JSON.parse(this.getCookie('localeCookie_jar'))['contentLocale'];
        }
        if (JSON.parse(this.getCookie('localeCookie_jar_aka'))) {
            this.preferredLanguage = JSON.parse(this.getCookie('localeCookie_jar_aka'))['preferredRegion'];
        }
        if (JSON.parse(this.getCookie('geolocation_aka_jar'))) {
            this.geolocation = JSON.parse(this.getCookie('geolocation_aka_jar'))['country'];
        }
        if (JSON.parse(this.getCookie('AFFILIATIONS_jar'))) {
            this.geolocation = JSON.parse(this.getCookie('AFFILIATIONS_jar'))['dcl']['storedAffiliations'][0];
        }
        if (JSON.parse(this.getCookie('AFFILIATIONS_jar'))) {
            this.geolocationTwo = JSON.parse(this.getCookie('AFFILIATIONS_jar'))['dcl']['storedAffiliations'][1];
        }

        // this.preferredLanguage = 'en_US'; // FOR TESTING ONLY
        // this.geolocation = 'USA'; //FOR TESTING ONLY

        this.selectedLanguage = this.preferredLanguage;

        if (/_USA_RESIDENT$/i.test(this.geolocation) || /US_RESIDENT$/i.test(this.geolocationTwo)) {
            this.geolocation = 'usa';
        }

        if (/^usa?$/i.test(this.geolocation)) {
            if (/^en([-_]us)?$/i.test(this.preferredLanguage)) {
                this.selectedLanguage = 'en_US';
            }
        }

        if (this.langSelection && this.preferredLanguage === 'en') {
            this.selectedLanguage = 'en_US';
        }

        this.readBannerToggle();
    }

    readBannerToggle() {
        this.environment = this.configService.getValue('environment');
        // this.environment = 'stage'; // FOR TESTING ONLY

        let cdnPrefix = 'stage.';
        if (this.environment === 'prod') {
            cdnPrefix = '';
        }

        this.httpClient.get('https://' + cdnPrefix + 'cdn1.parksmedia.wdprapps.disney.com/media/home/homepage-banner-toggles.json')
        .subscribe(json => {

            const bannerOverride = this.getCookie('dvicBannerToggle');
            if (bannerOverride) {
                const override = bannerOverride.split(',');
                if (override[0] === this.globalSiteId && override[1] === this.environment && override[2] === 'off') {
                    console.log('dvic turned off');
                    return json;
                }
            }
            this.tokenCookie = this.getCookie('tokenSwid');
            const showimage = this.getCookie('showbannnerimage');
            if (this.tokenCookie) {
                console.log('tokenSwid Cookie enabled');
                this.showDvicBanner();
                return json;
            }
            if (showimage) {
                this.showDvicBannerImage();
                return json;
            }
            this.dvicToggle = json;
            if (this.dvicToggle[this.globalSiteId][this.environment] === 'on') {
                this.showDvicBanner();
                return json;
            }
            if (this.dvicToggle[this.globalSiteId][this.environment] === 'off') {
                console.log('showing default banner image');
                this.showDvicBannerImage();
                return json;
            }
        }, error => { throw error; });
    }

    public showDvicBanner() {
        let token;
        if (this.tokenCookie) {
            token = this.tokenCookie.split(',')[0];
        }
        if (!token) {
            this.httpClient.get('/profile-api/authentication/get-client-token/').subscribe(json => {
                this.authToken = json['access_token'];
                this.dvicBannerCall();
            }, error => {
                console.log('error: could not get authentication token');
                console.log(error);
            });
        } else {
            this.authToken = token;
            this.dvicBannerCall();
        }
    }

    showDvicBannerImage() {
        if (this.webOrMobile ===  'mobile_web') {
           // use mobile photo
           this.dvicimage = 'mobile_web';
        } else {
            // use desktop photo
            this.dvicimage = 'web';
        }
    }

    dvicBannerCall() {
        let myswid;
        let userProfile;
        if (this.getCookie('rememberme')) {
            console.log('guest logged in');
            try {
                userProfile = JSON.parse(this.getCookie('rememberme'))['swid'];
                if (userProfile) {
                    myswid = userProfile;
                }
            } catch (error) {
                console.log(error);
            }
        }
        if (this.tokenCookie) {
            const swid = this.tokenCookie.split(',');
            if (swid.length > 1) {
                myswid = swid[1];
            }
        }

        if (this.environment === 'lt01') {
            this.environment = 'load';
        }

        if (this.environment === 'latest') {
            this.dvicScript = 'https://latest.cdn1.parksmedia.wdprapps.disney.com/media/dvic-banner/'
            + this.globalSiteId + '/wdpr-dvic-banner.js';
        } else if (this.environment === 'stage' || this.environment === 'load') {
            this.dvicScript = 'https://stage.cdn1.parksmedia.wdprapps.disney.com/media/dvic-banner/'
            + this.globalSiteId + '/wdpr-dvic-banner.js';
        } else {
            this.dvicScript = 'https://cdn1.parksmedia.wdprapps.disney.com/media/dvic-banner/'
            + this.globalSiteId + '/wdpr-dvic-banner.js';
        }

        const script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'dvicBannerEmbedScript';
            script.async = true;
            script.src = this.dvicScript;
            document.getElementsByTagName('body')[0].appendChild(script);

        window.onReadyDvicBanner = () => {
            console.log('banner ready');
            window.dvicBanner
                .configuration({
                apiPrefixPath: '/dvic', // remove when testing locally
                serviceTimeout: 5000,
                accessToken: this.authToken,
                envName: this.environment, // 'stage'
                languageHeader: this.selectedLanguage, // 'en_US' or 'en-US'
                params: {
                    siteId: this.globalSiteId, // 'dcl'
                    pageId: 'home',
                    device: this.webOrMobile,
                    swid: myswid
                }
            })
            .init();
            window.dvicBanner.loadBanner();
        };
        let flagBannerSeen = false;
        window.onDvicBannerDisplay = function(bannerrData) {
            if (window.WDPRO.Analytics.Framework.trackElement && document.getElementById('wdpr-dvic-banner')) {
                console.log('dvic analytics available');

                const banner = document.getElementById('wdpr-dvic-banner');
                this.inViewObserver = new IntersectionObserver((entries) => {
                    if (entries[0].isIntersecting && !flagBannerSeen) {
                        this.inViewObserver.unobserve(banner);
                        console.log('banner seen, sending impression');
                        if (bannerrData.hasOwnProperty('analytics') && bannerrData.analytics.hasOwnProperty('impression')) {
                            window.WDPRO.Analytics.Framework.trackElement(bannerrData.analytics.impression);
                        }
                        flagBannerSeen = true;
                    }
                });
                this.inViewObserver.observe(banner);

                window.onDvicBannerClick = function(data) {
                    if (data.hasOwnProperty('analytics') && data.analytics.hasOwnProperty('click')) {
                        window.WDPRO.Analytics.Framework.trackElement(data.analytics.click);
                    }

                    if (typeof data.redirectLink !== 'undefined') {
                        window.location.href = data.redirectLink;
                        return true;
                    }
                };
            }
        };
        window.onDvicBannerError = function(err) {
            console.log('[DVC Banner JS]', err);
        };
    }

}
